const users = [
    ["nail", "Наиль"],
    ["vladimir", "Владимир"],
    ["margarita", "Маргарита"],
    ["dameli", "Дамели"],
    ["evgeniy", "Евгений"],
];

module.exports = {
    users
}